import React from "react";
import { Row } from "react-bootstrap";

import { HookFormInput } from "components/hookForms";

import styles from "../filter.module.scss";

type DayHourMinuteSectionProps = {
	register: (Ref, RegisterOptions?) => void;
	section: any;
	name?: string;
	isInvalid?: boolean;
	isCustomName?: boolean;
	onBlur?: Function;
};

const DayHourMinuteSection = ({
	register,
	section,
	name,
	isInvalid,
	onBlur,
	isCustomName = false,
}: DayHourMinuteSectionProps) => {
	const { days, hours, minutes } = section;

	return (
		<div>
			{section?.title && (
				<div className={styles.ageTitle}>{section?.title}</div>
			)}
			<Row className="mb-1">
				<HookFormInput
					register={register}
					name={
						isCustomName ? `${name}.${days.name}` : `${days.name}`
					}
					normalize={days.normalize}
					isInvalid={isInvalid}
					onBlur={onBlur}
					label="Days"
					colInput={8}
					colLabel={4}
					autoComplete="off"
				/>
			</Row>
			<Row className="mb-1">
				<HookFormInput
					register={register}
					name={
						isCustomName ? `${name}.${hours.name}` : `${hours.name}`
					}
					normalize={hours.normalize}
					isInvalid={isInvalid}
					onBlur={onBlur}
					label="Hours"
					colInput={8}
					colLabel={4}
					autoComplete="off"
				/>
			</Row>
			<Row className="mb-0">
				<HookFormInput
					register={register}
					name={
						isCustomName
							? `${name}.${minutes.name}`
							: `${minutes.name}`
					}
					normalize={minutes.normalize}
					isInvalid={isInvalid}
					onBlur={onBlur}
					label="Minutes"
					colInput={8}
					colLabel={4}
					autoComplete="off"
				/>
			</Row>
		</div>
	);
};

export default DayHourMinuteSection;
